<template>

	<float-button
		:side="side"
		:icon="icon"
		:title="title"
		:color="color"
		@action="ghostSubmit()"
		/>

</template>

<script>

export default {
props: {side: {}, icon: {default: 'save'}, title: {}, color: {default: 'save'}, formId: {}},
methods: {
	ghostSubmit(){
		var ghostButton = document.createElement("button");
		var form = document.getElementById(this.formId);
		ghostButton.setAttribute('type', 'submit');
		form.appendChild(ghostButton);
		ghostButton.click();
		form.removeChild(ghostButton);
	}
},
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/FloatSubmitButton.vue